// The close of the beg branch, two days after it. The priest goes down in the dirt at the end
// of stranger/beg.js and the traveler walks off with the map; this is the town telling him what
// became of the man. Only the beg branch reaches here — the crime branch's traveler shot him and
// knows where he lies, and the labour branch's priest is still alive against the yard wall.
//
// It has to work twice, like everything before the last scene. Plain: a drunk finally drowned in
// a foot of water and it is nobody's fault. Underneath: he had days left in him until a dead man
// put a hand on his coat, and the last thing he asked for was to be left alone. The traveler
// takes the first reading and says so on the button, which is the same move he makes over the
// body in killed.js — `an accident. or so i tell myself.`
//
// No line names what he feels about it and none of the crowd speaks, so nothing here confirms or
// denies that he had a part in it. The last line is the priest's own words from beg.js, handed
// back.
import nextAction from 'model/actions/utilities/nextAction';

const strangerEnd = onDone => ({
  title: 'the stranger',
  description: [
    'no sign of him in days. i took him for run off',
    'a crowd at the bridge. children found something in the shallows and will not be moved off it',
    'they turn him over. the priest',
    'no mark on him. a man that drunk and water that cold',
    'he asked to be left be'
  ],
  buttons: [nextAction('An accident', () => onDone())]
});

export default strangerEnd;
